import {
  ChangeDetectorRef,
  Component,
  EventEmitter,
  OnDestroy,
  OnInit,
  TemplateRef,
  ViewChild,
  ViewChildren,
  inject,
  DestroyRef
} from "@angular/core";
import { CommonModule } from "@angular/common";
import { ClientInfoSectionComponent } from "./client-info-section/client-info-section.component";
import { SharedDataService, User } from "../shared-data.service";
import { AddClientModalService } from "../main/accountant/modals/add-client-modal.service";
import { CustomDataService } from "../main/accountant/setup-and-settings/client-contact-fields/custom-data.service";
import { AccountantService } from "../main/accountant/accountant.service";
import { WorkspacesService } from "../main/accountant/workspaces.service";
import { PeopleSectionComponent } from "./people-section/people-section.component";
import { DashboardService } from "../dashboard.service";
import { BsModalRef, BsModalService } from "ngx-bootstrap/modal";
import { HotToastService } from "@ngneat/hot-toast";
import { AddExistingClientModalComponent } from "../main/accountant/modals/addExistingClientModal.component";
import { AddClientModalComponent } from "../main/accountant/modals/addClientModal.component";
import { QuickAssignStaffModalComponent } from "../main/accountant/modals/quick-assign-staff-modal.component";
import { environment } from "src/environments/environment";
import { DashboardStore } from "../dashboard.store";
import { DeleteConfirmationModalComponent } from "../main/accountant/modals/delete-confirmation-modal.component";
import { LocalStorageService } from "src/app/utils/localstorage.service";
import { takeUntilDestroyed } from "@angular/core/rxjs-interop";

declare var jQuery: any;

@Component({
    selector: "app-client-details-v2",
    imports: [CommonModule, ClientInfoSectionComponent, PeopleSectionComponent],
    templateUrl: "./client-details-v2.component.html",
    styleUrls: ["./client-details-v2.component.scss"]
})
export class ClientDetailsV2Component implements OnInit, OnDestroy {
  constructor(
    private localStorage: LocalStorageService,
    private addClientModalService: AddClientModalService,
    private customDataService: CustomDataService,
    private accountantService: AccountantService,
    private workspacesService: WorkspacesService,
    private cdr: ChangeDetectorRef,
    private dashboardService: DashboardService,
    private toastr: HotToastService,
    private modalService: BsModalService,
    private dashboardStore: DashboardStore,
    public sharedDataService: SharedDataService
  ) { }

  @ViewChild("removeClientUserConfirmation")
  removeClientUserConfirmation: TemplateRef<any>;
  @ViewChild("removeInviteConfirmation")
  removeInviteConfirmation: TemplateRef<any>;

  user: User;
  modalRef: BsModalRef;
  bsModalRef: BsModalRef;
  user_being_removed = null;
  new_owner = "";
  invite_being_removed = null;
  current_company: any = {};
  data: any;
  tags = [];
  all_tags = [];
  isLoading: boolean = true;

  readonly destroyRef = inject(DestroyRef);

  ngOnDestroy(): void {
    // No need to manually unsubscribe
  }

  ngOnInit(): void {
    this.user = this.sharedDataService.user;
    this.addClientModalService.newInvite
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe((users: any[]) => {
        users.forEach((user) => {
          this.current_company.users.push(user);
        });
      });

    this.workspacesService.$company
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe((company) => {
        this.data = this.sharedDataService.data;

        if (company !== null) {
          this.current_company = company;
          this.current_company.notes = "";

          if (
            this.current_company["id"] != null &&
            this.data["user_type"] == 1
          ) {
            this.accountantService
              .get_client_details(this.current_company["id"])
              .then((res) => {
                this.current_company["users"] = res.clients;
                this.current_company["invites"] = res.invites;
                this.current_company["accountants"] = res.staff;
                this.current_company["data_field_values"] =
                  res.data_field_values;
                this.current_company["contacts"] = res.contacts;

                this.isLoading = false;
              });

            this.accountantService
              .getWorkspaceTags(this.current_company.company_conversation.uuid)
              .then((res) => {
                this.all_tags = res;
                this.tags = res;
              });
          }
        }
      });
  }

  confirmClientUserRemoval(user_id): void {
    this.dashboardService.show_loading.next(true);
    this.accountantService
      .delete_client_user(user_id, this.new_owner, this.current_company.id)
      .then(
        (res: any) => {
          const response = res;

          this.current_company.users = this.current_company.users.filter(
            (u) => {
              return u.user.id != user_id;
            }
          );

          this.dashboardService.show_loading.next(false);
          this.user_being_removed = null;
          this.toastr.success("Client user removed successfully.");
          this.cdr.detectChanges();
          this.modalRef.hide();
        },
        (err) => {
          this.dashboardService.show_loading.next(false);
          this.toastr.error(err.error.message);
          this.modalRef.hide();
        }
      );
  }

  decline(): void {
    this.modalRef.hide();
    this.new_owner = null;
    this.user_being_removed = null;
  }

  confirmInviteRemoval(invite_id): void {
    this.dashboardService.show_loading.next(true);
    this.accountantService.remove_invite(invite_id).then(
      (res: any) => {
        const response = res;

        this.current_company.invites = this.current_company.invites.filter(
          (i) => {
            return i.id != invite_id;
          }
        );

        this.dashboardService.show_loading.next(false);
        this.invite_being_removed = null;
        this.toastr.success("Invite removed successfully.");
        this.modalRef.hide();
      },
      (err) => {
        this.dashboardService.show_loading.next(false);
        this.toastr.error(err.error.message);
        this.modalRef.hide();
      }
    );
  }

  public openAddClientExistingUsersModal(company) {
    this.bsModalRef = this.modalService.show(AddExistingClientModalComponent, {
      class: "modal-lg",
    });
    if (company != null) {
      this.bsModalRef.content.invited_to = company.id;
      this.bsModalRef.content.name = company.name;
      this.bsModalRef.content.ngOnChanges({});
    }
  }

  public openAddClientModal(company) {
    this.modalService.onHide.subscribe((reason: string) => {
      if (this.current_company !== undefined) {
        if (this.current_company.invites !== undefined) {
          if (
            this.addClientModalService.invite !== null &&
            this.addClientModalService !== undefined
          ) {
            this.current_company.invites.push(
              this.addClientModalService.invite
            );
            this.addClientModalService.invite = null;
          }
        }
      }
    });

    this.bsModalRef = this.modalService.show(AddClientModalComponent, {
      class: "modal-lg"
    });
    if (company != null) {
      this.bsModalRef.content.invited_to = company.id;
      this.bsModalRef.content.name = company.name;
      this.bsModalRef.content.ngOnChanges({});
    }
  }

  removeClientUser(user): void {
    this.user_being_removed = user;
    this.modalRef = this.modalService.show(this.removeClientUserConfirmation, {
      class: "modal-sm",
    });
  }

  removeInvite(invite_id): void {
    this.invite_being_removed = invite_id;
    this.modalRef = this.modalService.show(this.removeInviteConfirmation, {
      class: "modal-sm",
    });
  }

  openAddStaffUserModal(company: any) {
    const assignStaffModal = this.modalService.show(
      QuickAssignStaffModalComponent,
      {
        class: "modal-lg",
        initialState: {
          companyId: company?.id,
          assignedUsers: this.current_company.accountants.map((u: any) => u.id),
        },
      }
    );
    assignStaffModal.content?.success.subscribe((users: any[]) =>
      users.forEach((u) => this.current_company.accountants.push(u))
    );
  }

  inviteContactToBecomeClient(contact): void {
    this.dashboardService.show_loading.next(true);
    this.accountantService
      .invite_client(
        contact.name,
        contact.email,
        null,
        2,
        this.current_company.id,
        2
      )
      .then(
        (res: any) => {
          this.dashboardService.show_loading.next(false);
          this.toastr.success(res.message);
          if (res.company) {
            this.dashboardStore.addClient(res.company);
          }
          this.current_company.invites.push(res.invite);
        },
        (err) => {
          this.toastr.error(err.error.message);

          this.dashboardService.show_loading.next(false);
        }
      );
  }

  async deleteContact(contact_uuid) {
    const initialState = {
      displayName: "the contact from the workspace",
    };
    this.bsModalRef = this.modalService.show(DeleteConfirmationModalComponent, {
      initialState,
    });

    this.bsModalRef.content.onClose.subscribe(async (res: boolean) => {
      if (res) {
        this.current_company.contacts = this.current_company.contacts.filter(
          (contact) => contact.uuid !== contact_uuid
        );
        const { message } = await this.customDataService.deleteContact(
          contact_uuid
        );
        this.dashboardService.show_loading.next(false);
        this.toastr.success(message);
      }
    });
  }

  unassignAccountantFromClient(data) {
    const { user_id: accountant_id, company_id } = data;
    this.accountantService
      .unassignAccountantFromClient(accountant_id, company_id)
      .then(
        (res) => {
          this.toastr.success("Accountant unassigned successfully.");

          this.current_company.accountants =
            this.current_company.accountants.filter((a) => {
              return a.user.id != accountant_id;
            });

          this.cdr.detectChanges();
        },
        (err) => {
          this.toastr.error("Error unassigning accountant.");
        }
      );
  }

  sendInviteEmail(invite_id): void {
    this.dashboardService.show_loading.next(true);
    this.accountantService.send_invite_email(invite_id).then(
      (res: any) => {
        this.dashboardService.show_loading.next(false);
        this.toastr.success(res.message);
      },
      (err) => {
        this.dashboardService.show_loading.next(false);
        this.toastr.error(err.error.message);
      }
    );
  }

  viewInviteLink(invite) {
    var $temp = jQuery("<input>");
    jQuery("body").append($temp);
    $temp
      .val(`${environment.frontUrl}registration/join/${invite.uuid}`)
      .select();
    document.execCommand("copy");
    $temp.remove();

    this.toastr.success("Invite link copied to clipboard.");
  }
}
